export default "__VITE_ASSET__c9cc34af__"